/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FoodDrinkAlcoGlassWineIcon16Light } from './FoodDrinkAlcoGlassWineIcon16Light';
import { FoodDrinkAlcoGlassWineIcon16Regular } from './FoodDrinkAlcoGlassWineIcon16Regular';
import { FoodDrinkAlcoGlassWineIcon16Solid } from './FoodDrinkAlcoGlassWineIcon16Solid';
import { FoodDrinkAlcoGlassWineIcon20Light } from './FoodDrinkAlcoGlassWineIcon20Light';
import { FoodDrinkAlcoGlassWineIcon20Regular } from './FoodDrinkAlcoGlassWineIcon20Regular';
import { FoodDrinkAlcoGlassWineIcon20Solid } from './FoodDrinkAlcoGlassWineIcon20Solid';
import { FoodDrinkAlcoGlassWineIcon24Regular } from './FoodDrinkAlcoGlassWineIcon24Regular';
import { FoodDrinkAlcoGlassWineIcon24Solid } from './FoodDrinkAlcoGlassWineIcon24Solid';
import { FoodDrinkAlcoGlassWineIcon32Regular } from './FoodDrinkAlcoGlassWineIcon32Regular';
import { FoodDrinkAlcoGlassWineIcon64Regular } from './FoodDrinkAlcoGlassWineIcon64Regular';
var sizes = {
    16: {
        light: FoodDrinkAlcoGlassWineIcon16Light,
        regular: FoodDrinkAlcoGlassWineIcon16Regular,
        solid: FoodDrinkAlcoGlassWineIcon16Solid,
    },
    20: {
        light: FoodDrinkAlcoGlassWineIcon20Light,
        regular: FoodDrinkAlcoGlassWineIcon20Regular,
        solid: FoodDrinkAlcoGlassWineIcon20Solid,
    },
    24: {
        regular: FoodDrinkAlcoGlassWineIcon24Regular,
        solid: FoodDrinkAlcoGlassWineIcon24Solid,
    },
    32: {
        regular: FoodDrinkAlcoGlassWineIcon32Regular,
    },
    64: {
        regular: FoodDrinkAlcoGlassWineIcon64Regular,
    },
};
export var FoodDrinkAlcoGlassWineIcon = forwardRef('FoodDrinkAlcoGlassWineIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
